import { render, staticRenderFns } from "./BirthIcon.vue?vue&type=template&id=56adc010"
import script from "./BirthIcon.vue?vue&type=script&lang=js"
export * from "./BirthIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports